export const DEFAULT_LNG: number = 140.887;